export const PACKAGES = [
  {
    id: "pkg-va",
    name: "Virginia Concealed Carry Permit",
    tagline: "VA CHP",
    states: ["VA"],
    price: 50,
    image: "/courses/pkg-va.jpg",
    features: [
      "Virginia state-compliant concealed carry training",
      "Firearm safety fundamentals",
      "Virginia self-defense law overview",
      "Beginner friendly",
      "Certificate provided",
    ],
    cta: "Book Now",
    popular: false,
  },
  {
    id: "pkg-va-md",
    name: "Virginia + Maryland Package",
    tagline: "VA CHP + MD Wear & Carry",
    states: ["VA", "MD"],
    price: 125,
    image: "/courses/pkg-va-md.jpg",
    features: [
      "Virginia CHP training",
      "Maryland Wear & Carry training",
      "Maryland required live-fire qualification",
      "Multi-state training package",
      "Certificate provided",
    ],
    cta: "Reserve Seat",
    popular: false,
  },
  {
    id: "pkg-va-fl",
    name: "Virginia + Florida Package",
    tagline: "VA CHP + FL Non-Resident",
    states: ["VA", "FL"],
    price: 125,
    image: "/courses/pkg-va-fl.jpg",
    features: [
      "Virginia CHP training",
      "Florida non-resident permit eligibility training",
      "Firearm safety and legal overview",
      "Multi-state coverage option",
      "Certificate provided",
    ],
    cta: "Reserve Seat",
    popular: false,
  },
  {
    id: "pkg-elite",
    name: "Tri-State Defender Elite Package",
    tagline: "Expanded Reciprocity — VA · MD · FL Coverage",
    states: ["VA", "MD", "FL"],
    price: 175,
    image: "/courses/pkg-va-md-fl.jpg",
    features: [
      "Virginia CHP",
      "Maryland Wear & Carry",
      "Florida Non-Resident Permit",
      "Maryland live-fire qualification included",
      "Maximum multi-state reciprocity",
      "Certificate provided",
    ],
    cta: "Book Now",
    popular: true,
    available: true,
  },
  {
    id: "pkg-dmv-tristate",
    name: "DMV Tri-State Package",
    tagline: "VA CHP + DC CCW + MD Wear & Carry",
    states: ["VA", "DC", "MD"],
    price: 175,
    image: "/courses/pkg-dmv-tristate.jpg",
    features: [
      "Virginia Concealed Carry",
      "Washington DC Concealed Carry",
      "Maryland Wear & Carry",
      "Full DMV-area reciprocity",
      "Certificate provided",
    ],
    cta: "Coming Soon",
    popular: false,
    available: false,
  },
  {
    id: "pkg-dmv-fl-ut-elite",
    name: "DMV + Florida + Utah Elite Package",
    tagline: "VA · DC · MD · FL · UT — Maximum Coverage",
    states: ["VA", "DC", "MD", "FL", "UT"],
    price: 250,
    image: "/courses/pkg-dmv-fl-ut-elite.jpg",
    features: [
      "Virginia Concealed Carry",
      "Washington DC Concealed Carry",
      "Maryland Wear & Carry",
      "Florida Non-Resident CCW",
      "Utah Non-Resident CFP",
      "Maximum multi-state reciprocity",
      "Certificate provided",
    ],
    cta: "Coming Soon",
    popular: false,
    available: false,
  },
];

export const PERMIT_ADDONS = [
  { code: "MD", name: "Maryland", available: true },
  { code: "FL", name: "Florida", available: true },
  { code: "UT", name: "Utah", available: false },
  { code: "DC", name: "DC", available: false },
];

export const PERMIT_ADDON_PRICING = {
  perState: 50,
  bundle2: 80,
  bundleSavings: 20,
  bundleHelper:
    "Bundle & Save — Any 2 qualifying add-on states for $80.",
  introHelper:
    "Already certified in one state? Expand your coverage with additional qualifying state certifications.",
};

// Compute add-on price for an array of selected codes
export function calculateAddOnPrice(selectedCodes = []) {
  const active = PERMIT_ADDONS.filter(
    (a) => a.available && selectedCodes.includes(a.code)
  );
  const count = active.length;
  if (count === 0) return { count: 0, total: 0, isBundle: false };
  if (count === 1)
    return { count: 1, total: PERMIT_ADDON_PRICING.perState, isBundle: false };
  // 2+ → bundle, with extra over 2 charged at perState
  const extras = Math.max(0, count - 2);
  return {
    count,
    total: PERMIT_ADDON_PRICING.bundle2 + extras * PERMIT_ADDON_PRICING.perState,
    isBundle: true,
  };
}

export const JUNIOR_PROGRAM = {
  id: "junior-preparedness",
  name: "Junior Preparedness Program",
  tagline: "Youth Firearm Safety Mentorship",
  minAge: 10,
  price: 35,
  priceUnit: "session",
  priceLabel: "Investment",
  perLabel: "Per youth participant",
  description:
    "Youth firearm safety mentorship for ages 10+ accompanied by a parent or guardian.",
  bookingValue: "Junior Preparedness Program",
};

export const COURSES = [
  {
    id: "concealed-carry",
    name: "Concealed Carry Course",
    short: "USCCA-aligned concealed carry curriculum.",
    duration: "4 Hours",
    level: "All Levels",
    price: "$50",
    description:
      "A comprehensive concealed carry curriculum aligned with USCCA standards. We cover safe handling, marksmanship, draw mechanics, situational awareness, and a general overview of legal use-of-force concepts. Live-fire qualification on the range.",
    learn: [
      "Safe handling and storage of a concealed firearm",
      "Holster selection and concealed draw mechanics",
      "Marksmanship fundamentals at defensive distances",
      "Situational awareness and de-escalation",
      "Overview of legal use-of-force principles (general education only)",
    ],
    gear: [
      "Functional handgun (rentals available)",
      "Quality holster + sturdy belt",
      "Eye and ear protection",
      "100 rounds of factory ammunition",
      "Hat, closed-toe shoes, weather-appropriate clothing",
    ],
    image:
      "https://images.unsplash.com/photo-1612777660478-735ae8b55004?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    icon: "fa-solid fa-bullseye",
  },
  {
    id: "basic-handgun",
    name: "Basic Handgun Fundamentals",
    short: "Build a rock-solid foundation from zero.",
    duration: "2 Hours",
    level: "Beginner",
    price: "$50",
    description:
      "Brand-new to firearms? This is your starting line. We cover everything from how a handgun works to the fundamentals of accurate, repeatable, safe shooting in a calm, judgement-free environment.",
    learn: [
      "How a handgun functions (revolver vs semi-auto)",
      "Grip, stance, sight alignment, trigger control",
      "Safe loading, unloading, and clearing malfunctions",
      "Range etiquette and the four cardinal safety rules",
      "Confidence-building live-fire on paper targets",
    ],
    gear: [
      "Just yourself (handgun & ammo provided if needed)",
      "Eye and ear protection (loaners available)",
      "Closed-toe shoes, hat, comfortable clothing",
    ],
    image: "/courses/basic-handgun.jpg",
    icon: "fa-solid fa-crosshairs",
  },
  {
    id: "home-defense",
    name: "Home Defense Training",
    short: "Protect what matters most under pressure.",
    duration: "2 Hours",
    level: "Intermediate",
    price: "$85",
    description:
      "A scenario-driven course that translates range fundamentals into real-world home defense readiness. Covers low-light shooting principles, building a family defense plan, and defensive movement.",
    learn: [
      "Building a family defense plan and safe rooms",
      "Low-light shooting principles and weapon-mounted lights",
      "Defensive movement and use of cover",
      "Communication with family / 911 under stress",
      "Realistic, decision-based shooting drills",
    ],
    gear: [
      "Reliable handgun or shotgun + 150 rounds",
      "Holster + sturdy belt",
      "Weapon-mounted or handheld light (rentals available)",
      "Eye and ear protection",
    ],
    image: "/courses/home-defense.jpg",
    icon: "fa-solid fa-house-shield",
  },
];

export const STATS = [
  { value: "VETERAN", label: "Owned & Operated", icon: "fa-solid fa-shield-halved" },
  { value: "USCCA", label: "Certified Instructor", icon: "fa-solid fa-certificate", badge: "/badges/uscca-certified-instructor.png" },
  { value: "100%", label: "Safety Focused", icon: "fa-solid fa-helmet-safety" },
  { value: "REAL", label: "World Training", icon: "fa-solid fa-bullseye" },
];

export const TESTIMONIALS = [
  {
    quote:
      "Training with Darrien really helped improve my confidence with firearm handling and dry fire fundamentals. He pays attention to details that make a huge difference.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "The SIRT pistol training was extremely helpful. Darrien explained trigger control, sight alignment, and movement in a way that finally clicked for me.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "Darrien helped me choose a firearm that actually fit my hands, comfort level, and intended use instead of just recommending what was popular.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "Frontline Defense provided solid marksmanship coaching and practical dry fire drills I could continue practicing at home.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "Very knowledgeable instructor who takes time to explain fundamentals, firearm safety, and shooting mechanics without overcomplicating things.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "The dry fire exercises and trigger control coaching noticeably improved my accuracy and confidence with my handgun.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "Darrien helped me better understand optics, grip, stance, and firearm setup for personal defense and range use.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "The SIRT training sessions were one of the most useful parts for me. It helped build confidence before transitioning to live fire.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "I appreciated that Darrien focused on proper fundamentals and realistic training instead of just rushing through drills.",
    role: "Verified Frontline Student",
  },
  {
    quote:
      "Frontline Defense gave me practical guidance not only on shooting fundamentals, but also on selecting the right firearm and setup for my needs.",
    role: "Verified Frontline Student",
  },
];

export const FAQS = [
  {
    q: "Do I need to own a firearm to take a class?",
    a: "No. Rental firearms are available for our Basic Handgun and Concealed Carry classes. Just let us know when booking and we'll have one ready for you.",
  },
  {
    q: "What should I bring to my first class?",
    a: "Eye and ear protection (loaners available), a hat, closed-toe shoes, weather-appropriate clothing, water, and a willingness to learn. If you have your own firearm, bring it unloaded and cased.",
  },
  {
    q: "How long are the courses?",
    a: "Basic Handgun is 4 hours, Home Defense is 6 hours, and the full Concealed Carry Course is 8 hours. We never rush instruction — quality over speed.",
  },
  {
    q: "Where are courses held?",
    a: "Our home base is in Chester, Virginia (Greater Richmond area). We also offer mobile training — we'll come to your range, property, or group — perfect for private clients, families, businesses, and church safety teams. Exact location and directions are sent after booking confirmation.",
  },
  {
    q: "Is the Concealed Carry Course USCCA certified?",
    a: "Yes — our concealed carry curriculum is USCCA-aligned and taught by a USCCA Certified Instructor. The class is designed to give you a strong foundation in concealed carry — but specific permit/legal requirements vary by state. We can't give legal advice; please consult an attorney for state-specific licensing questions.",
  },
  {
    q: "Are women's-only or private classes available?",
    a: "Yes. Private one-on-one sessions, women's-only group classes, and small-group family sessions are all available on request. Contact us directly to schedule.",
  },
  {
    q: "What's the refund / reschedule policy?",
    a: "Reschedule up to 72 hours before your course at no charge. Refunds are available up to 7 days prior to the class start date. Full policy provided after booking.",
  },
  {
    q: "Do you offer training for businesses or churches?",
    a: "Absolutely. We offer customized security and personal-protection training for small businesses, security teams, and church safety teams. Contact us for a tailored quote.",
  },
];

export const GALLERY = [
  "/gallery/01.jpg",
  "/gallery/02.jpg",
  "/gallery/03.jpg",
  "/gallery/04.jpg",
  "/gallery/05.jpg",
];

export const HERO_IMAGE =
  "https://static.prod-images.emergentagent.com/jobs/dd61af15-6ac7-4744-b454-8a7efc44311d/images/2fc22672b9a5d2a3a534b4e9de108850e7fde57635e4dfd9dc707777d01ddad9.png";

export const ABOUT_IMAGE = "/logos/raised-on-frontline.png";

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/classes", label: "Training" },
  { to: "/booking", label: "Book" },
  { to: "/merch", label: "Merch" },
  { to: "/gallery", label: "Gallery" },
  { to: "/faq", label: "FAQ" },
  { to: "/contact", label: "Contact" },
];

export const BRAND = {
  name: "Frontline Defense LLC",
  tagline: "Protection Through Preparation",
  motto: "Defend Your Own",
  phone: "+1 (804) 420-2533",
  phoneRaw: "+18044202533",
  email: "defendyourown@frontlinedefensehq.com",
  location: "Chester, VA — Mobile Available",
  instagram: "https://www.instagram.com/frontlinedefense_official?igsh=MWNqdGoxM2VrdTZk&utm_source=qr",
  youtube: "https://youtube.com/@frontlinedefense-dyo?si=Wn5oD-QvTjE7OeZN",
  logos: {
    primary: "/logos/primary.png",
    defendYourOwn: "/logos/defend-your-own.png",
    raisedOnFrontline: "/logos/raised-on-frontline.png",
    frontlineFamily: "/logos/frontline-family.png",
  },
};
